export default __webpack_public_path__ + "static/media/roadmap_path_tablet.a31e8ceb.png";